<div
  ref="root"
  class="nb-select"
  :class="{ open: isOpen, focused: isOpen, filled: hasValue, error: error }"
>
  <!-- Trigger -->
  <div
    tabindex="0"
    role="combobox"
    @click="toggle"
    @keydown.esc="close"
    @keydown="handleKeydown"
    class="nb-select__trigger"
  >
    <template v-if="selectedOption">
      <div class="selected-holder">
        <slot name="selected" :option="selectedOption">
          {{ getOptionLabel(selectedOption) }}
        </slot>
      </div>
    </template>
    <span class="icon" :class="isOpen ? 'iconfont-triangle-down' : 'iconfont-triangle-right'"></span>

    <!-- Floating Label -->
    <label v-if="label" class="nb-select__label">
      {{ label }}
    </label>
  </div>

  <!-- Dropdown -->
  <div v-if="isOpen" class="nb-select__dropdown" ref="dropdown" role="listbox">
    <div
      role="option"
      @click="select(option)"
      class="nb-select__option"
      :key="getOptionValue(option)"
      :ref="el => setOptionRef(el)"
      v-for="(option, index) in options"
      :aria-selected="index === highlightedIndex"
      :class="{ highlighted: index === highlightedIndex }"
    >
      <slot name="option" :option="option">
        {{ getOptionLabel(option) }}
      </slot>
    </div>
  </div>

  <!-- Error -->
  <div v-if="error" class="error-message">
    {{ error }}
  </div>
</div>
